export default __webpack_public_path__ + "static/media/no-plan-artwork.360203c7.svg";